import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import introBackgroundImg from 'on_web/assets/images/background_intro.svg';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import { Trans } from 'react-i18next';
import MobileStepper from '@material-ui/core/MobileStepper';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'on_web/components/shared/Common/Button';
import { useTranslation } from 'react-i18next';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ContainerWithBackground from 'on_web/components/shared/Common/ContainerWithBackgroundImg';
import UserProfileContext from 'on_web/context/userProfileContext';

import useUsersApi from 'on_web/hooks/useUsersApi';

export default function Intro(props) {
  const { t } = useTranslation();
  const letsGoText = t('onboarding.introSection.intro.letsGo');
  const skipIntroText = t('onboarding.introSection.intro.skipIntro');

  const context = React.useContext(UserProfileContext);
  let userMetaData = context ? context.user_metadata : null;

  const [step, setStep] = useState(
    userMetaData && userMetaData.introTextStep ? userMetaData.introTextStep : 0
  );

  const [{ saveUserData }] = useUsersApi();

  // override for MobileStepper
  const useStyles = makeStyles({
    mobileStepperRoot: {
      backgroundColor: 'rgba(0, 0, 255, 0)',
    },
  });
  const classes = useStyles();

  const onClickNext = () => {
    if (step < 3) {
      setStep(step + 1);
      saveStep();
    } else {
      setIntroSeen();
      saveStep(step);
    }
  };

  const onClickBack = () => {
    if (step >= 1) {
      setStep(step - 1);
      saveStep();
    } else if (props.onClickBack) {
      props.onClickBack();
    }

    saveStep(step);
  };

  const setIntroSeen = () => {
    if (props.onClickNext && userMetaData) {
      userMetaData.introSeen = true;
      props.onClickNext(userMetaData);
    }
  };

  const saveStep = () => {
    if (userMetaData) {
      userMetaData.introTextStep = step;
      saveUserData(userMetaData);
    }
  };

  return (
    <div>
      <Header />
      <ContainerWithBackground
        image={introBackgroundImg}
        maxWidth={'686px'}
        maxHeight={'643px'}
        height={'85vh'}
        width={'100vw'}
        marginTop={'0vh'}
      >
        <Box
          color="#ffffff"
          maxWidth="350px"
          position="relative"
          pr={{ xs: 4 }}
          pl={{ xs: 4 }}
          left={{ sm: '17%' }}
          top={{ sm: '10%', xs: '20%' }}
        >
          <SwipeableViews
            index={step}
            onSwitching={(index, type) => {
              if (type === 'end') {
                setStep(index);
              }
            }}
          >
            <Typography variant="h4">
              <Trans i18nKey="onboarding.introSection.intro.step1" />
            </Typography>
            <Typography variant="h4">
              <Trans i18nKey="onboarding.introSection.intro.step2" />
            </Typography>
            <Typography variant="h4">
              <Trans i18nKey="onboarding.introSection.intro.step3" />
            </Typography>
            <Typography variant="h4">
              <Trans i18nKey="onboarding.introSection.intro.step4" />
            </Typography>
          </SwipeableViews>

          <Box justifyContent="center" display="flex" m={2}>
            <MobileStepper
              variant="dots"
              steps={4}
              position="static"
              activeStep={step}
              classes={{
                root: classes.mobileStepperRoot,
              }}
              onClick={ev => console.log(ev)}
            />
          </Box>
        </Box>
      </ContainerWithBackground>
      <StickyNavigation
        hideBack={true}
        onClickBack={() => onClickBack()}
        onClickNext={() => onClickNext()}
      />
    </div>
  );
}
